import { RequestNewLeaseRequest } from "@swarm/shared/schemas";
import { LicensesByPeriodResponse } from "@swarm/shared/schemas";
import { GetLeasesResponse } from "@swarm/shared/schemas";
import { ReactNode } from "react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";

export const RequestNewLeaseFormSchema = z.object({
  quantity: z
    .string({
      error: "Quantity cannot be empty.",
    })
    .refine((val) => /^\d+$/.test(val), {
      message: "Quantity must be a whole number.",
    })
    .refine((val) => parseInt(val, 10) >= 1, {
      message: "You must lease at least 1 license.",
    }),
  duration: z
    .string({
      error: "Duration cannot be empty.",
    })
    .regex(/\d/i),
});

export type LicenseLeasesContextControllerActions = {
  requestNewLease: {
    isLoading: boolean;
    isError: boolean;
    error?: string;
  };
};

export type LicenseLeasesContextControllerProps = {
  children: ReactNode;
};

export type LicenseLeasesContextType = {
  /** `undefined` when the upstream read failed — the controller does not throw. */
  getLicensesByOwner: (owner: string) => Promise<LicensesByPeriodResponse | undefined>;
  getLeasesByOwner: (owner: string) => Promise<GetLeasesResponse | undefined>;
  /** Resolves once the request is accepted; errors surface on `actions`. */
  requestNewLease: (args: RequestNewLeaseRequest) => Promise<void>;
  actions: LicenseLeasesContextControllerActions;
  requestNewLeaseForm: UseFormReturn<z.infer<typeof RequestNewLeaseFormSchema>>;
  licensesByOwner?: LicensesByPeriodResponse;
  leasesByOwner?: GetLeasesResponse;
};
